import NoOfStoresByFacings from "./NoOfStoresByFacings";
export default NoOfStoresByFacings;
